import Colors from "../../styles/colors";

const styles = {
  container: {
    flexDirection: "column",
    height: "calc(100vh - 112px)",
    maxHeight: "calc(100vh - 112px)",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: "25px",
  },
  conversationContainer: {
    mb: 1,
    height: "100%",
    maxHeight: "100%",
    flexDirection: "column",
    width: "100%",
    maxWidth: 1000,
    overflow: "auto",
    "&::-webkit-scrollbar": {
      height: "10px",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: Colors.Highnote.blue4T10,
      borderRadius: "8px",
    },
    "&::-webkit-scrollbar-thumb": {
      boxShadow: "inset 0 0 6px rgba(0, 0, 0, 0.3)",
      height: "10px",
      backgroundColor: Colors.Highnote.blue4T90,
      borderRadius: "8px",
    },
  },
  inputContainer: {
    p: "2px 4px",
    display: "flex",
    alignItems: "center",
    width: "100%",
    maxWidth: 1000,
  },
  inputDivider: {
    minHeight: 48,
    m: 1,
    ml: 2.5,
    height: "100%",
    borderColor: Colors.Highnote.black,
  },
  hignomeAvatar: {
    marginTop: "4px",
    padding: "3px",
    border: "2px solid transparent",
    background:
      "linear-gradient(#fff, #fff) padding-box, linear-gradient(45deg, #f81ce5, #7928ca) border-box",
  },
  systemMessagecontainer: {
    m: 2,
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    borderColor: "red",
    borderWidth: "2px",
    marginBottom: "34px",
    maxWidth: "100%",
  },
  userMessageContainer: {
    m: 2,
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "flex-end",
    borderColor: "blue",
    borderWidth: "8px",
    marginBottom: "34px",
    maxWidth: "100%",
  },
  systemMessage: {
    maxWidth: "80%",
    padding: "16px",
    marginLeft: "8px",
    color: Colors.Highnote.black,
    backgroundColor: "#E9ECEF"
  },
  userMessage: {
    maxWidth: "80%",
    padding: "16px",
    marginRight: "8px",
    backgroundImage: `linear-gradient(to right, ${Colors.Highnote.blue1}, ${Colors.Highnote.purple3})`,
    color: Colors.Highnote.white,
  },
  loadingContainer: {
    m: 2,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
};

export default styles;
